import { raw } from '@hid/driver/tool'
import { HuoChaiRenDevices, OutputMode, type KIO, type KK, type Layout, type MacroType, type Record, type SetMagnetSenior, type VK } from '../../define/define'
import type { ResReadSetting } from '../../define/response'
import { dataProfileManage, ensureLightModeSettings, resolveLightModeSetting, type DataProfile } from '../../snapshot/profile'
import { Fe87v2DeviceList } from '@/define/device_vendor'
import { deviceManager } from '@hid/device/device_manager'
import { createDecorates } from '@hid/define/define_profile'
import { ra68SideLight } from '@hid/define/define_side_light'
import { applyDeviceFnLayoutOverlay, applyDeviceKeyLayoutOverlay } from './read_settings_capability'

export const handleReadSettings = async () => {
  const data = dataProfileManage().dataProfile
  const currentLightMode = resolveLightModeSetting(data, data.LightMode)
  const res: ResReadSetting = {
    Layout: {
      KeyMap: new Map<KK, number>(),
      KeyMapModifier: new Map<KK, number[]>(),
      // KeyMouse: new Map<KK, number>(),
      Magenet: new Map<KK, SetMagnetSenior>(),
      // KeyMedia: new Map<KK, number>(),
      Macros: new Map<KK, Record[]>(),
      MacroType: new Map<KK, MacroType>(),
      KeyMapFire: new Map<KK, number[]>(),
    },
    LayoutFn: {
      KeyMap: new Map<KK, number>(),
      KeyMapModifier: new Map<KK, number[]>(),
      // KeyMouse: new Map<KK, number>(),
      Magenet: new Map<KK, SetMagnetSenior>(),
      // KeyMedia: new Map<KK, number>(),
      Macros: new Map<KK, Record[]>(),
      MacroType: new Map<KK, MacroType>(),
      KeyMapFire: new Map<KK, number[]>(),
    },
    LightLastIsCustom: data.LightLastIsCustom,
    LightMode: currentLightMode,
    LightModeSettings: ensureLightModeSettings(data),
    LightCustom: data.ColorsCustom,
    ColorsDynamic: data.ColorsDynamic,
    Mouse: data.Mouse,
    Decorates: getDecorates(data),
  }
  setLayout(res.Layout, raw(data.Keys), data, false)
  await applyDeviceKeyLayoutOverlay(res.Layout)
  setLayout(res.LayoutFn, raw(data.Keys), data, true)
  await applyDeviceFnLayoutOverlay(res.LayoutFn)

  return res
}

function setLayout(layout: Layout, keys: KIO[], data: DataProfile, IsFn: boolean) {
  if (keys.length < 1) {
    return layout
  }
  keys.forEach((value) => {
    const kk = value.Input.KK
    if (value.Input.WithFN == IsFn) {
      if (value.Output.Mode == OutputMode.Key) {
        if (value.Input.WithModifier.length > 0) {
          const modifierData = value.Input.WithModifier
          modifierData.push(value.Output.VK)
          layout.KeyMapModifier.set(kk, modifierData)
        } else {
          layout.KeyMap.set(kk, value.Output.VK)
        }
      } else if (value.Output.Mode == OutputMode.Fire) {
        layout.KeyMapFire.set(kk, value.Output.Extension)
      } else if (value.Output.Mode == OutputMode.Magnet) {
        const magnetData = data.MagnetData.get(value.Output.DataIndex)
        if (magnetData != undefined) {
          layout.Magenet.set(kk, magnetData)
        }
      } else if (value.Output.Mode == OutputMode.Macro) {
        const macroData = data.Macros.get(value.Output.DataIndex)
        if (macroData != undefined) {
          layout.Macros.set(kk, macroData)
          layout.MacroType.set(kk, { LoopType: value.Output.Extension[0], LoopTimes: value.Output.Extension[1] })
        }
      }
    }
  })
}

// 兼容旧版fe87v2侧光灯
function getDecorates(data: DataProfile) {
  if (Fe87v2DeviceList.includes(deviceManager.deviceID) && data.Decorates == undefined) {
    data.Decorates = createDecorates(0, 3, 3, 0x0000ff, new Map<KK, number>())
    data.Decorates[0].LightMode.Mode = data.Decorates[0].LightMode.SideMode
  }
  if (data.Decorates == undefined && HuoChaiRenDevices.includes(deviceManager.deviceID)) {
    data.Decorates = createDecorates(1, 80, 80, 0, ra68SideLight)
  }
  return data.Decorates
}
